/** v1 placeholder — real URL comes from stop.evidence_requirements / fastfield_url when configured. */
export const FASTFIELD_PLACEHOLDER_URL = "https://fastfieldforms.com";

export function resolveFastFieldUrl(stopFastFieldUrl: string | null): string {
  return stopFastFieldUrl?.trim() || FASTFIELD_PLACEHOLDER_URL;
}
